import { goToRacingGame } from '@racings/helpers/goToRacingGame';
import { virtualSportsIds } from '@common/constants/enums/virtualSports';
import { browserHistory } from './browserHistory';

export const goToGame = ({
  gameId,
  isActive = false,
  listType = 'all',
  gameType,
  racingType,
  marketId,
  regionId,
  sportId,
  sportAlias = 'all',
  regionAlias = 'all',
  competitionId = 'all',
  routePrefix,
  isRacingEvent = false,
} = {}) => {
  if (virtualSportsIds.includes(sportId)) {
    browserHistory.push(`/betting/virtuals/${sportId}/${regionId}/${competitionId}/${gameId}`);
  } else if (isRacingEvent) {
    goToRacingGame({
      gameId,
      regionId,
      racingType,
      competitionId,
    });
  } else {
    const query = marketId ? `?marketId=${marketId}` : '';
    const path =
      isActive || listType === 'outright'
        ? `/betting/${gameType}/${listType}/${sportAlias}/${regionAlias || 'all'}/${competitionId}`
        : `/betting/${gameType}/${listType}/${sportAlias}/${regionAlias || 'all'}/${competitionId}/${gameId}`;

    const gameDetailsPath = `${path}${query}`;

    browserHistory.push(gameDetailsPath);
  }
};
